import React, { useEffect, useState, useRef } from 'react'
import {
  AutoComplete,
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Icon,
  Input,
  message,
  Modal,
  Row,
  Select,
  Spin,
  Table,
  Tabs,
  Tag,
  Tooltip,
  Typography
} from 'antd';
import Highlighter from 'react-highlight-words';
import { connect } from 'react-redux'
import AuditVoucherSearch from '../../components/AuditVoucherSearch'
import {
  getAssetsByAuditVoucher,
  fetchFilter,
  getPvByVoucher,
  getAssetsForReconciliation,
  saveReconciliationData,
  processReconciliationData,
  exportReconciliationData
} from '../../appRedux/actions';
import ActionModal from "./ActionModal";
import AstRecord from './ast/AstRecord';
import AstReconciliation from "./ast";
import moment from 'moment';
import PvReconciliation from './pv';
import AssetsReconciliation from './assets';

const { TabPane } = Tabs;
const { Option } = AutoComplete;

export const Reconciliation = (props) => {
  const [voucher, setVoucher] = useState(null);
  const [filterLocation, setFilterLocation] = useState(null);
  const [filterClient, setFilterClient] = useState(null);
  const [filterStatus, setFilterStatus] = useState(null);
  const [data, setData] = useState([])
  const [locations, setLocations] = useState([]);
  const [clients, setClients] = useState([]);

  const [pvAssetListData, setPvAssetListData] = useState([])
  // const [pvAssetColumns, setPvAssetColumns] = useState([])
  const [assetListData, setAssetListData] = useState([])
  const [masterAssets, setMasterAssets] = useState([])

  const [exportedData, setExportedData] = useState(null)


  useEffect(() => {
    props.fetchFilter('Reconciliation');
    // props.getAssetsForReconciliation();
  }, []);

  useEffect(() => {
    if (props.authUser && props.authUser.locations) {
      const locations = [...props.authUser.locations].sort((a, b) => a.name.localeCompare(b.name));
      // locations.sort((a, b) => a.name <= b.name)
      setLocations(locations)
    }

    if (props.authUser && props.authUser.clients) {
      const clients = [...props.authUser.clients].sort((a, b) => a.name.localeCompare(b.name));
      // clients.sort((a, b) => a.name <= b.name)
      setClients(clients)
    }

  }, [props.authUser]);

  const fetchAssetsFromAST = () => {
    if (voucher) {
      props.getAssetsByAuditVoucher(voucher, filterLocation, filterClient, filterStatus);
    }
  }

  useEffect(() => {
    // console.log(props.reconciliationAssets);

    setData(props.reconciliationAssets && props.reconciliationAssets.astAssets || [])
    setPvAssetListData(props.reconciliationAssets && props.reconciliationAssets.pvAssets || [])
    setAssetListData(props.reconciliationAssets && props.reconciliationAssets.allAssets || [])
  }, [props.reconciliationAssets]);



  useEffect(() => {
    setMasterAssets((assetListData || []).filter(d => {
      const li = props.authUser.locations.findIndex(loc => loc._id === d.location)
      return !d || (li >= 0 && props.authUser.locations[li]['name'] !== 'SOLD')
    }))
  }, [assetListData])

  // after saving AST records
  useEffect(() => {
    const savedData = props.reconciliationSavedAstAssets || [];
    if (savedData && savedData.length) {
      let isAssetUpdated = false;
      savedData.forEach(d => {
        const ix = data.findIndex(doc => doc._id.toString() === (d.astAsset && d.astAsset.assetRecordId && d.astAsset.assetRecordId.toString() || ''))
        if (ix >= 0) {
          // console.log('saving ...', ix);

          data[ix]['saveId'] = d._id;
          data[ix]['isAlreadySaved'] = true;
          data[ix]['actionTaken'] = d.actionTaken

          if (d.actionTaken && d.actionTaken !== 'NEW_ASSET') {
            const i = masterAssets.findIndex(doc => doc.assetCode === data[ix]['assetCode'])
            if (i >= 0) {
              isAssetUpdated = true
              masterAssets[i]['status'] = d.actionTaken
              masterAssets[i]['original_status'] = d.reconcileStatus
              masterAssets[i]['ast'] = data[ix]
              masterAssets[i]['isAlreadySaved'] = true
              masterAssets[i]['isProcessed'] = false;
              // masterAssets[i]['asset_before_location'] = masterAssets[i]['location']
              // masterAssets[i]['asset_before_client'] = masterAssets[i]['client']
            }
          }
        }
      })
      if (isAssetUpdated)
        setMasterAssets([...masterAssets])
      // console.log(data);
      setData([...data]);
      // console.log('saved');
    }
  }, [props.reconciliationSavedAstAssets]);

  // after saving PV records
  useEffect(() => {
    const savedData = props.reconciliationSavedPvAssets || [];
    if (savedData && savedData.length) {
      let isAssetUpdated = false;
      savedData.forEach(d => {
        const ix = pvAssetListData.findIndex(doc => doc._id.toString() === (d.pvAsset && d.pvAsset.assetRecordId && d.pvAsset.assetRecordId.toString() || '') && (doc.tempAssetCode || '') === (d.pvAsset.tempCode || ''))
        if (ix >= 0) {
          // console.log('saving ...', ix);

          pvAssetListData[ix]['saveId'] = d._id;
          pvAssetListData[ix]['isAlreadySaved'] = true;
          pvAssetListData[ix]['actionTaken'] = d.actionTaken

          // Only a linked action (LINK_ASSET) carries a refRecordId pointing at a
          // master asset. NEW_ASSET / IGNORE have no linked asset, so there is
          // nothing to update on masterAssets for them.
          // Fixes a crash: the previous inner findIndex used `d` again (shadowing
          // the saved record) and dereferenced d.actionTaken.refRecordId on a
          // master-asset row that has no actionTaken. Also the guard compared an
          // object to the string 'NEW_ASSET' (always true), so NEW_ASSET/IGNORE
          // wrongly entered this block.
          if (d.actionTaken && d.actionTaken.refRecordId) {
            const i = masterAssets.findIndex(a => a._id.toString() === d.actionTaken.refRecordId.toString())
            if (i >= 0) {
              isAssetUpdated = true
              masterAssets[i]['status'] = d.actionTaken
              masterAssets[i]['original_status'] = d.reconcileStatus
              masterAssets[i]['pv'] = pvAssetListData[ix]
              masterAssets[i]['isAlreadySaved'] = true
              masterAssets[i]['isProcessed'] = false;
              // masterAssets[i]['asset_before_location'] = masterAssets[i]['location']
              // masterAssets[i]['asset_before_client'] = masterAssets[i]['client']
            }
          }
        }
      })

      if (isAssetUpdated)
        setMasterAssets([...masterAssets])
      // console.log(pvAssetListData);
      setPvAssetListData([...pvAssetListData]);
      // console.log('saved');
    }
  }, [props.reconciliationSavedPvAssets]);


  //after processing AST records
  useEffect(() => {
    const processedData = props.reconciliationProcessedAstAssets || [];
    if (processedData && processedData.length) {
      let isAssetUpdated = false;
      processedData.forEach(d => {
        const ix = data.findIndex(doc => doc._id.toString() === (d.astAsset && d.astAsset.assetRecordId && d.astAsset.assetRecordId.toString() || ''))
        if (ix >= 0) {
          // console.log('saving ...x ', ix);

          data[ix]['saveId'] = d.saveId || data[ix]['saveId'];
          data[ix]['isAlreadySaved'] = true;
          data[ix]['actionTaken'] = d.actionTaken

          data[ix]['isProcessed'] = d.isProcessed;
          data[ix]['processedOn'] = d.processedOn && moment(d.processedOn).format('YYYY-MM-DD');
          data[ix]['processedRemark'] = d.processedRemark || ''

          //update masterAsset as per 
          if (d.actionTaken && d.actionTaken !== 'NEW_ASSET') {
            const i = masterAssets.findIndex(doc => doc.assetCode === data[ix]['assetCode'])
            if (i >= 0) {
              isAssetUpdated = true
              masterAssets[i]['status'] = d.actionTaken
              masterAssets[i]['original_status'] = d.reconcileStatus
              masterAssets[i]['processed_remark'] = d.processedRemark
              masterAssets[i]['ast'] = data[ix]
              masterAssets[i]['isAlreadySaved'] = true
              masterAssets[i]['isProcessed'] = d.isProcessed;
              // masterAssets[i]['asset_before_location'] = masterAssets[i]['location']
              // masterAssets[i]['asset_before_client'] = masterAssets[i]['client']
            }
          }
        }
      })
      if (isAssetUpdated)
        setMasterAssets([...masterAssets])
      // console.log(data);
      setData([...data]);
      // console.log('saved');
    }
  }, [props.reconciliationProcessedAstAssets]);

  //after processing PV records
  useEffect(() => {
    const processedData = props.reconciliationProcessedPvAssets || [];
    // console.log(processedData);

    if (processedData && processedData.length) {
      let isAssetUpdated = false;
      processedData.forEach(d => {
        const ix = pvAssetListData.findIndex(doc => doc._id.toString() === (d.pvAsset && d.pvAsset.assetRecordId && d.pvAsset.assetRecordId.toString() || '') && (doc.tempAssetCode || '') === (d.pvAsset.tempCode || ''))
        if (ix >= 0) {
          // console.log('saving ...', ix);

          pvAssetListData[ix]['saveId'] = d.saveId || pvAssetListData[ix]['saveId'];
          pvAssetListData[ix]['isAlreadySaved'] = true;
          pvAssetListData[ix]['actionTaken'] = d.actionTaken

          pvAssetListData[ix]['isProcessed'] = d.isProcessed;
          pvAssetListData[ix]['processedOn'] = d.processedOn && moment(d.processedOn).format('YYYY-MM-DD');
          pvAssetListData[ix]['processedRemark'] = d.processedRemark || ''

          //update masterAsset as per pv update
          // Same fix as the PV-save handler: only LINK_ASSET carries a refRecordId,
          // and the inner findIndex must not shadow the processed record `d`.
          if (d.actionTaken && d.actionTaken.refRecordId) {
            const aIx = masterAssets.findIndex(a => a._id.toString() === d.actionTaken.refRecordId.toString())
            if (aIx >= 0) {
              isAssetUpdated = true
              masterAssets[aIx]['status'] = d.actionTaken
              masterAssets[aIx]['original_status'] = d.reconcileStatus
              masterAssets[aIx]['processed_remark'] = d.processedRemark
              masterAssets[aIx]['isAlreadySaved'] = true
              masterAssets[aIx]['isProcessed'] = d.isProcessed;
              masterAssets[aIx]['pv'] = pvAssetListData[ix]
              // masterAssets[aIx]['asset_before_location'] = masterAssets[ix]['location']
              // masterAssets[aIx]['asset_before_client'] = masterAssets[ix]['client']
            }
          }
        }
      })

      if (isAssetUpdated)
        setMasterAssets([...masterAssets])

      // console.log(pvAssetListData);
      setPvAssetListData([...pvAssetListData]);
      // console.log('saved');
    }
  }, [props.reconciliationProcessedPvAssets]);

  const selectVoucherHandle = (v) => {
    if (v)
      setVoucher(v)
  }


  const exportData = () => {
    exportReconciliationData(exportedData, locations, clients);
  }

  const [statusOptions, setStatusOptions] = useState([])

  useEffect(() => {
    const options = props.filters && props.filters['reconciliationStatus'] && props.filters['reconciliationStatus']['options'] && props.filters['reconciliationStatus']['options']['enum']
    setStatusOptions(options)
  }, [props.filters]);

  const handleTabSelect = (val) => { }
  // console.log(val === 3, val === '3');
  // if (val === '3' && voucher && !pvAssetListData && !pvAssetListData.length)
  //   props.getPvByVoucher(voucher);
  // }

  // useEffect(() => {
  //   setPvAssetListData(props.reconciliationAssets && props.reconciliationAssets.pvAssets || [])
  // }, [props.reconciliationAssets]);

  return (
    <div>

      <Spin spinning={false}>
        <Card className={`gx-card-metrics`} title={`AST Reconcilation`}>

          <Row gutter={8}>
            <Col xs={24} sm={12} md={8} lg={4} xl={4}>
              <AuditVoucherSearch
                styleName="gx-lt-icon-search-bar-lg"
                placeholder="Search Audit Voucher..."
                onSelect={(value) => selectVoucherHandle(value)}
                authUser={props.authUser}
                defaultAsset={props.data && props.data.auditVoucher}
              />
            </Col>
            <Col xs={24} sm={12} md={8} lg={4} xl={4}>
              <AutoComplete style={{ width: '100%' }} onSelect={(val) => setFilterLocation(val)} onChange={(v) => !v && setFilterLocation(null)}
                allowClear multi placeholder="Select Location"
                filterOption={(inputValue, option) =>
                  option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                }
              >
                {
                  (locations || []).map(loc => <Option key={loc._id} value={loc._id} title={loc.name}>{loc.name}</Option>)
                }
              </AutoComplete>

            </Col>
            <Col xs={24} sm={12} md={8} lg={4} xl={4}>
              <AutoComplete style={{ width: '100%' }} onSelect={(val) => setFilterClient(val)} onChange={(v) => !v && setFilterClient(null)}
                allowClear multi placeholder="Select Sub Location"
                filterOption={(inputValue, option) =>
                  option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                }
              >
                {
                  (clients || []).map(cl => <Option key={cl._id} value={cl._id} title={cl.name}>{cl.name}</Option>)
                }
              </AutoComplete>
            </Col>
            <Col xs={24} sm={12} md={8} lg={4} xl={4}>
              <AutoComplete style={{ width: '100%' }} onSelect={(val) => setFilterStatus(val)} onChange={(v) => !v && setFilterStatus(null)}
                allowClear multi placeholder="Select Status"
                filterOption={(inputValue, option) =>
                  option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                }
              >
                {
                  (statusOptions || []).map(st => <Option key={st} value={st} title={st}>{st}</Option>)
                }
              </AutoComplete>
            </Col>
            <Col xs={24} sm={12} md={8} lg={4} xl={4}>
              <Button type="default" htmlType="button" loading={props.loading} onClick={fetchAssetsFromAST} disabled={!voucher}>
                Generate
              </Button>
              {/* ={!data || !data.length} */}
              <Tooltip placement="top" title={'Click all tabs to select'}>
                <Button type="dashed" icon='download' htmlType="button"
                  loading={props.loading} onClick={exportData} disabled={!assetListData || !assetListData.length}>
                  Export
                </Button>
              </Tooltip>
            </Col>
          </Row>

          <Tabs defaultActiveKey="1" onTabClick={handleTabSelect}>
            <TabPane tab="AST" key="1">
              <AstReconciliation clients={clients} locations={locations} data={data} voucher={voucher} setExportedData={setExportedData} exportedData={exportedData} {...props} />
            </TabPane>
            <TabPane tab="PV" key="2">
              <PvReconciliation clients={clients} locations={locations} assets={assetListData} data={pvAssetListData} voucher={voucher} exportedData={exportedData} setExportedData={setExportedData} {...props} />
            </TabPane>
            <TabPane tab="Asset" key="3">
              <AssetsReconciliation clients={clients} locations={locations} data={masterAssets} astData={data} pvData={pvAssetListData} exportedData={exportedData} setExportedData={setExportedData} voucher={voucher} {...props} />
            </TabPane>

          </Tabs>
        </Card>

      </Spin>
    </div>
  )
}

const mapStateToProps = ({ reconciliation, auth, commonData, asset, preVerification }) => ({
  reconciliationAssets: reconciliation.reconciliationAssets,
  reconciliationSavedAstAssets: reconciliation.reconciliationSavedAstAssets,
  reconciliationSavedPvAssets: reconciliation.reconciliationSavedPvAssets,
  reconciliationProcessedAstAssets: reconciliation.reconciliationProcessedAstAssets,
  reconciliationProcessedPvAssets: reconciliation.reconciliationProcessedPvAssets,
  authUser: auth.authUser,
  filters: commonData.filters,
  loading: commonData.loading,
  pvRecordByVoucher: preVerification.pvRecordByVoucher,
  assetsForReconciliation: asset.assetsForReconciliation
})

const mapDispatchToProps = {
  getAssetsByAuditVoucher,
  fetchFilter,
  getAssetsForReconciliation,
  getPvByVoucher,
  saveReconciliationData,
  processReconciliationData
}

export default connect(mapStateToProps, mapDispatchToProps)(Reconciliation)
